import styled from 'styled-components';

export const RegisterResumeStyle = styled.div`
  .card-check-box {
    .MuiIconButton-label {
      margin-right: 10px;
    }
    .MuiCheckbox-colorPrimary.Mui-checked {
      color: ${(props) => props.theme.primary.primary50};
    }
  }

  .link {
    background-color: transparent;
    color: ${(props) => props.theme.primary.primary50};
    text-decoration: underline;
    border: none;
    outline: none;
    padding: 0;
    margin: 0;
    font-size: 16px;
    cursor: pointer;
  }
`;
